<template>
  <article>
    <div :class="style['image']" :style="checkSlideMediaContent(slide)">
      <poweredby-icon v-if="slide.powered_by" :icon="slide.powered_by" />
    </div>
    <div class="inset">
      <p>
        <strong>{{ slide.detail.title }}</strong> {{ slide.detail.price }}
      </p>
      <div class="inset">
        <div
          v-for="(section, index) in slide.detail.sections"
          ref="sections"
          :class="style['list-explanation']"
        >
          <p>
            <i :class="section.icon" />
            {{ section.heading }}
          </p>
          <ul v-if="section.content[0]">
            <li v-for="(item, index) in section.content">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div :class="style.select">
      <p v-if="slide.detail.url" class="hovering">
        <a
          v-if="slide.detail.url"
          :href="slide.detail.url"
          target="_blank"
          :class="style.external"
          >{{ slide.detail.url_text }}</a
        >
      </p>
      <p
        v-for="(action, index) in actions"
        class="hovering"
        :class="active ? '' : 'inactive'"
        @click="sendReply(action)"
      >
        <a v-if="action.url" :href="action.url" target="_blank" :class="style.external">{{
          action.text
        }}</a>
        <template v-if="!action.url">{{ action.text }}</template>
      </p>
    </div>
  </article>
</template>

<script>
import style from './scss/_pages.scss'
import { Chat } from 'src/apis'
import PoweredbyIcon from 'UtilityComponents/PoweredbyIcon.vue'
import { useChatStore } from 'Store/chat'
import { mapState } from 'pinia'
import { useDetailsPageStore } from 'Store/details-page'

export default {
  setup() {
    return {
      chatStore: useChatStore(),
      detailsPageStore: useDetailsPageStore()
    }
  },

  components: {
    PoweredbyIcon
  },
  data() {
    return {
      active: true,
      style
    }
  },
  computed: {
    ...mapState(useDetailsPageStore, {
      slide: 'slide',
      chat: 'chat'
    }),
    actions() {
      return this.slide.actions.filter((action) => !action.hide_on_detail)
    }
  },
  methods: {
    sendReply(action) {
      if (this.active && !action.url) {
        this.active = false
        if (action.step === 'back') {
          // user clicked back button, call API and return
          Chat.goToState(this.chatStore.chatId)
        } else {
          const options = {
            messageAction: action.action,
            messageID: this.chat.id
          }
          Chat.sendMessage(action.reply, options)
        }
        this.detailsPageStore.closeDetailsPageShown()
      }
    },
    checkSlideMediaContent(slide) {
      if (slide.media_content) {
        return { backgroundImage: `url(${slide.media_content})` }
      } else {
        return ''
      }
    }
  }
}
</script>
